(function ($) {
    "use strict";
    $(function () {
        if ($('.js-user-opinion-form').length === 0) {
            return;
        }

        $(document).on("click", ".js-submit-opinion", function (e) {
            e.preventDefault();

            var form = $('.js-user-opinion-form');
            var data = grabFormAsObject(form);

            if ($('#opinion').val().length < 25) {
                alert('Kérjük kicsit részletesebben írja problémáját.');
                return false;
            }

            $.ajax({
                url: localize.ajaxurl,
                type: 'POST',
                data: {
                    action: "submit_opinion",
                    data: data
                },
                success: function (response) {
                    form.trigger("reset");
                    $('.js-success-opinion-submit').removeClass("d-none");
                    $('.js-hide-for-success-submit').addClass("d-none");
                }
            });
        });
    });
})(jQuery);
